


















































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { HttpService } from "@/services/api/httpService";

import { Application } from "@/types/application";

@Component
export default class ApplicationList extends Vue {
  total = 100;
  searchCriteria: string = "";
  httpServiceArray = new HttpService<Array<Application>>();
  httpService = new HttpService<Application>();
  pageSize: any = localStorage.getItem("pageSize")
    ? localStorage.getItem("pageSize")
    : 25;
  pageNumber: number = 1;
  responseArray: Array<Application> = new Array<Application>();
  showModal: boolean = false;
  removeData: Application = new Application();

  getList() {
    this.httpServiceArray
      .getListSearch(
        "applications",
        this.pageSize,
        this.pageNumber,
        this.searchCriteria
      )
      .then(response => {
        if (response.status != 404) {
          this.responseArray = response.data;
          // this.total = JSON.parse(response.headers["x-pagination"]).totalCount;  // TODO we need the total count to be brought back in the headers
        } else this.responseArray = new Array<Application>();
      });
  }
  reset() {
    this.searchCriteria = "";
    this.getList();
  }
  @Watch("pageSize", { immediate: true }) onPageSize() {
    localStorage.setItem("pageSize", this.pageSize);
    this.getList();
  }
  @Watch("pageNumber") onPageChange() {
    this.getList();
  }
  created() {
    this.getList();
  }

  add() {
    this.$router.push({
      name: "applicationsAdd"
    });
  }
  confirmRemove(data: Application) {
    this.showModal = true;
    this.removeData = data;
  }
  async remove(data: Application) {
    await this.httpService
      .deleteItem("applications", data.applicationId)
      .then(response => {
        this.responseArray = this.responseArray.filter(
          (item: Application) => item.applicationId != data.applicationId,
          this.$notification.success(
            `${data.applicationName} successfully removed!`
          )
        );
      });
    this.showModal = false;
    this.getList();
  }
  edit(data: Application) {
    this.$router.push({
      name: `applicationsEdit`,
      params: { id: data.applicationId }
    });
  }
}
